import { type UseMutationOptions, useMutation } from '@tanstack/react-query';
import {
  type RefreshPdpV1WorkspacesWorkspaceIdPdpsPdpIdRefreshPostData,
  type RefreshPdpV1WorkspacesWorkspaceIdPdpsPdpIdRefreshPostError,
  type RefreshPdpV1WorkspacesWorkspaceIdPdpsPdpIdRefreshPostResponses,
  refreshPdpV1WorkspacesWorkspaceIdPdpsPdpIdRefreshPost,
} from '../../generated';

export type RefreshPdpMutationVariables = RefreshPdpV1WorkspacesWorkspaceIdPdpsPdpIdRefreshPostData['path'];

export type RefreshPdpMutation =
  RefreshPdpV1WorkspacesWorkspaceIdPdpsPdpIdRefreshPostResponses[keyof RefreshPdpV1WorkspacesWorkspaceIdPdpsPdpIdRefreshPostResponses];

export const useRefreshPdpMutation = <
  TError = RefreshPdpV1WorkspacesWorkspaceIdPdpsPdpIdRefreshPostError,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<RefreshPdpMutation, TError, RefreshPdpMutationVariables, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) => {
  return useMutation<RefreshPdpMutation, TError, RefreshPdpMutationVariables, TContext>({
    mutationKey: ['RefreshPdp'],
    mutationFn: async ({ workspace_id, pdp_id }: RefreshPdpMutationVariables) => {
      const { data } = await refreshPdpV1WorkspacesWorkspaceIdPdpsPdpIdRefreshPost({
        path: { workspace_id, pdp_id },
        throwOnError: true,
      });
      return data;
    },
    ...options,
  });
};

useRefreshPdpMutation.fetcher = (
  { workspace_id, pdp_id }: RefreshPdpMutationVariables,
  _headers?: RequestInit['headers'],
) => {
  return async () => {
    const { data } = await refreshPdpV1WorkspacesWorkspaceIdPdpsPdpIdRefreshPost({
      path: { workspace_id, pdp_id },
      throwOnError: true,
    });
    return data;
  };
};
